import React from 'react';

const reasons = [
  {
    icon: '🏆',
    title: 'Certified Experts',
    desc: 'Our consultants hold certifications from Databricks, Microsoft, AWS, Google Cloud, OpenAI, and Anthropic.',
  },
  {
    icon: '🌍',
    title: 'North America Focus',
    desc: 'Deep knowledge of US, Canadian, and Mexican business regulations, tax structures, and market dynamics.',
  },
  {
    icon: '⚡',
    title: 'Fast Time-to-Value',
    desc: 'Proven frameworks and accelerators let us deliver working solutions in weeks, not quarters.',
  },
  {
    icon: '🔗',
    title: 'Cross-Platform Integration',
    desc: 'We connect Databricks, Power Platform, and AI tools into cohesive, end-to-end data and automation pipelines.',
  },
  {
    icon: '🛡️',
    title: 'Security & Compliance First',
    desc: 'Every solution is designed with SOC 2, PIPEDA, CCPA, HIPAA, and enterprise security in mind.',
  },
  {
    icon: '🤝',
    title: 'Long-Term Partnership',
    desc: 'We act as an extension of your team — not just a vendor — with dedicated account managers and 24/7 support.',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose Spiked Qcumber?</h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            We're not a generalist consulting firm. We bring deep, specialized expertise in the technologies that matter most to data-driven North American enterprises.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((r, i) => (
            <div key={i} className="bg-white rounded-2xl p-7 shadow-md hover:shadow-lg transition-shadow border border-gray-100">
              <div className="text-4xl mb-4">{r.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{r.title}</h3>
              <p className="text-gray-500 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
